<template>
    <div class="tab-favorites" v-if="!isMobile">
        <div v-if="favoriteProjects.length" class="tab-favorites__section">
            <Projects
                :projects="favoriteProjects"
                :projectsCount="favoriteProjectsCount"
                :isLoadingProjects="isLoadingProjects"
                :expandedEntityId="expandedEntityId"
                entityKey="favorites-projects"
                @onFetchMore="onShowMoreProjects"
                @onExpandedTags="onExpandedTags"
            />
        </div>
        <div v-if="favoriteEvents.length" class="tab-favorites__section">
            <Events
                :events="favoriteEvents"
                :eventsCount="favoriteEventsCount"
                :isLoadingEvents="isLoadingEvents"
                :expandedEntityId="expandedEntityId"
                entityKey="favorites-events"
                @onFetchMore="onShowMoreEvents"
                @onExpandedTags="onExpandedTags"
            />
        </div>

        <div v-if="favoriteInternships.length" class="tab-favorites__section">
            <Internships
                :internships="favoriteInternships"
                :internshipsCount="favoriteInternshipsCount"
                :isLoadingInternships="isLoadingInternships"
                :expandedEntityId="expandedEntityId"
                entityKey="favorites-internships"
                @onFetchMore="onShowMoreInternships"
                @onExpandedTags="onExpandedTags"
            />
        </div>

        <div class="tab-favorites__section">
            <EmptyMessage
                v-if="isNotFound && isFirstLoaded && !isLoadingFavorites"
                text="Добавляй в «Избранное» возможности, к которым хочешь вернуться."
            />
            <LoadingMessage v-if="isLoadingFavorites" />
        </div>
    </div>
    <div class="tab-favorites" v-else>
        <Tabs :activeField="tabActiveField" isBgMode :slotsHeaders="tabs" @change-field="setField">
            <template #ProjectsTab>
                <EmptyMessage
                    v-if="isFirstLoaded && !isLoadingFavorites && !favoriteProjects.length"
                    text="Добавляй в «Избранное» возможности, к которым хочешь вернуться."
                />
                <Projects
                    :projects="favoriteProjects"
                    :projectsCount="favoriteProjectsCount"
                    :isLoadingProjects="isLoadingProjects"
                    :expandedEntityId="expandedEntityId"
                    entityKey="favorites-projects-mobile"
                    @onFetchMore="onShowMoreProjects"
                    @onExpandedTags="onExpandedTags"
                />
            </template>
            <template #EventsTab>
                <EmptyMessage
                    v-if="isFirstLoaded && !isLoadingFavorites && !favoriteEvents.length"
                    text="Добавляй в «Избранное» возможности, к которым хочешь вернуться."
                />
                <Events
                    :events="favoriteEvents"
                    :eventsCount="favoriteEventsCount"
                    :isLoadingEvents="isLoadingEvents"
                    :expandedEntityId="expandedEntityId"
                    entityKey="favorites-events-mobile"
                    @onFetchMore="onShowMoreEvents"
                    @onExpandedTags="onExpandedTags"
                />
            </template>
            <template #InternshipsTab>
                <EmptyMessage
                    v-if="isFirstLoaded && !isLoadingFavorites && !favoriteInternships.length"
                    text="Добавляй в «Избранное» возможности, к которым хочешь вернуться."
                />
                <Internships
                    :internships="favoriteInternships"
                    :internshipsCount="favoriteInternshipsCount"
                    :isLoadingInternships="isLoadingInternships"
                    :expandedEntityId="expandedEntityId"
                    entityKey="favorites-internships-mobile"
                    @onFetchMore="onShowMoreInternships"
                    @onExpandedTags="onExpandedTags"
                />
            </template>
        </Tabs>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Projects from './components/category/Projects.vue';
import Events from './components/category/Events.vue';
import Internships from './components/category/Internships.vue';
import Tabs from '@/components/UI/Tabs';

import LoadingMessage from './components/parts/LoadingMessage.vue';
import EmptyMessage from './components/parts/EmptyMessage.vue';

export default {
    name: 'Tabfavorites',
    components: {
        Projects,
        Events,
        Internships,
        Tabs,
        LoadingMessage,
        EmptyMessage,
    },
    data() {
        return {
            isLoadingProjects: false,
            isLoadingEvents: false,
            isLoadingInternships: false,
            expandedEntityId: null,
            tabActiveField: 0,
            tabs: [
                {
                    name: 'ProjectsTab',
                    title: 'Проекты',
                },
                {
                    name: 'EventsTab',
                    title: 'Обучение',
                },
                {
                    name: 'InternshipsTab',
                    title: 'Стажировки',
                },
            ],
        };
    },
    computed: {
        ...mapGetters(['isMobile']),
        ...mapGetters('track', [
            'myInterests',
            'favoriteProjects',
            'favoriteEvents',
            'favoriteInternships',
            'favoriteEventsCount',
            'favoriteProjectsCount',
            'favoriteInternshipsCount',
            'isFirstLoaded',
            'isLoadingFavorites',
        ]),
        isNotFound() {
            return (
                this.favoriteProjects.length === 0 &&
                this.favoriteEvents.length === 0 &&
                this.favoriteInternships.length === 0
            );
        },
    },
    methods: {
        ...mapActions('track', ['fetchFavoriteProjects', 'fetchFavoriteEvents', 'fetchFavoriteInternships']),

        onExpandedTags(val) {
            this.expandedEntityId = val;
        },

        setField(index) {
            this.tabActiveField = index;
        },

        async onShowMoreInternships() {
            if (this.favoriteInternshipsCount > this.favoriteInternships.length && !this.isLoadingInternships) {
                this.isLoadingInternships = true;
                try {
                    await this.fetchFavoriteInternships({ take: 4, skip: this.favoriteInternships.length });
                } finally {
                    this.isLoadingInternships = false;
                }
            }
        },
        async onShowMoreProjects() {
            if (this.favoriteProjectsCount > this.favoriteProjects.length && !this.isLoadingProjects) {
                this.isLoadingProjects = true;
                try {
                    await this.fetchFavoriteProjects({ take: 4, skip: this.favoriteProjects.length });
                } finally {
                    this.isLoadingProjects = false;
                }
            }
        },
        async onShowMoreEvents() {
            if (this.favoriteEventsCount > this.favoriteEvents.length && !this.isLoadingEvents) {
                this.isLoadingEvents = true;
                try {
                    await this.fetchFavoriteEvents({ take: 4, skip: this.favoriteEvents.length });
                } finally {
                    this.isLoadingEvents = false;
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.tab-favorites {
    padding: urem(20);

    @include on-desktop {
        padding: urem(40) urem(40) 0 urem(40);
    }

    &__section {
        margin-bottom: urem(32);
    }

    :deep(.tabs) {
        margin-bottom: urem(20);

        .tab {
            font-size: urem(14);
        }
        .active {
            color: rgba(70, 99, 171, 1);
            font-size: urem(14);
            font-weight: 500;
        }
    }
}
</style>
